import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.search.js";
import React from 'react';
import { useLocation, useHistory } from 'react-router-dom';
import createLocation from 'utils/createLocation';
import queryparse from 'tricks/string/queryparse';
import ContactFormModal from './ContactFormModal';
import CompleteProfileModal from './CompleteProfileModal';
import { useFetchUserProfile } from 'actions/userProfile';
function GlobalModals() {
  var history = useHistory();
  var location = useLocation();
  var searchParams = queryparse(location.search);
  var _useFetchUserProfile = useFetchUserProfile(),
    userProfile = _useFetchUserProfile.userProfile,
    isLoading = _useFetchUserProfile.isLoading;
  function removeModalQuery() {
    history.push(createLocation(location, {
      modal: undefined
    }));
  }
  if (searchParams.modal === 'contact-form') {
    return /*#__PURE__*/React.createElement(ContactFormModal, {
      onClose: removeModalQuery
    });
  } else if (searchParams.modal === 'complete-profile') {
    if (!isLoading && userProfile) {
      return /*#__PURE__*/React.createElement(CompleteProfileModal, {
        onClose: removeModalQuery,
        userProfile: userProfile
      });
    } else {
      return null;
    }
  }
  return null;
}
export default GlobalModals;